import { Box, Heading } from '@chakra-ui/react';

import { Card } from '~/components/card';
import { Glyph } from '~/components/glyph';
import { Markdown } from '~/components/markdown';

import { CaseStudyProcessStep } from '../models/case-study-content';

export function CaseStudyProcessStepCard({ processStep }: { processStep: CaseStudyProcessStep }) {
  return (
    <Card as='section' padding={{ base: '24px 16px 24px 16px', md: '64px 192px 64px 192px' }}>
      <Glyph height={64} name={processStep.glyphName} width={64} />
      <Heading as='h2' color='accent.sea-foam.700' fontWeight='600' marginBottom='32px' size='h5'>
        {processStep.title}
      </Heading>

      <Box display='flex' flexWrap='wrap' gap='40px'>
        {processStep.markdownContent.map((content) => (
          <Box key={content.title}>
            <Heading as='h3' marginBottom='8px' size='h3'>
              {content.title}
            </Heading>
            <Markdown markdownText={content.body} />
          </Box>
        ))}
      </Box>
    </Card>
  );
}
